import styled from 'styled-components';

export const SortTypesContainer = styled.div`
  position: relative;
`;

export const CurrentSortType = styled.button`
  position: relative;
  
  display: flex;
  align-items: center;
  
  margin: 0;
  padding: 15px 0;
  
  font-size: 14px;
  color: inherit;
  
  background-color: transparent;
  border: none;
  outline: none;
  
  cursor: pointer;
  
  svg {
    margin-left: 10px;
    
    fill: ${({ theme }) => theme.blue}
  }
`;
